/**
 * Cores dos status de pedido — FONTE ÚNICA. São as cores originais das raias do
 * Recebedor de Pedidos, reaproveitadas nos marcadores do mapa da Roteirização para a
 * mesma cor significar a mesma coisa nas duas telas:
 * - amarelo: aceito (0, 1, 2);
 * - laranja: em preparação (7, 10);
 * - roxo:    pronto — aguardando entregador / retirada (6);
 * - azul:    em entrega (3);
 * - verde:   finalizado (4, 5, 9);
 * - vermelho: cancelado (negativos).
 */
export const COR_STATUS_ACEITO = "#f0bb1f"
export const COR_STATUS_PREPARO = "#fd7e14"
export const COR_STATUS_PRONTO = "#6f42c1"
export const COR_STATUS_EM_ROTA = "#0080ff"
export const COR_STATUS_FINALIZADO = "#51a351"
export const COR_STATUS_CANCELADO = "#dc3545"
